module.exports = __webpack_public_path__ + "90d1676003d9c28c04994c18bfd8b558.woff2";